import React, {Component} from "react";
import InternalSpecialityEnum from "../../treatment/enums/referral/InternalSpecialityEnum";
import InterventionTypeEnum from "../../treatment/enums/referral/InterventionTypeEnum";

export default class ReferralsReportView extends Component {

    render() {
        return (
            <>
                {
                    this.props.referral != null && this.props.referral.internals.length > 0 &&
                    <div>
                        <div>
                            <table className={"visit-history-table"}>
                                <tbody>
                                <tr style={{backgroundColor: "rgba(197, 224, 181, 0.4)"}}>
                                    <th>Speciality</th>
                                    <th>Provider Name</th>
                                    <th>Treatment Modalities</th>
                                    <th>No. Of Sessions</th>
                                    <th>Remarks</th>
                                </tr>
                                {
                                    this.props.referral.internals.map((item, index) => {
                                            return (
                                                <tr key={index} style={{backgroundColor: "white"}}>
                                                    <td>{item.speciality ? InternalSpecialityEnum[item.speciality].name : item.provider?.speciality.name}</td>
                                                    <td>{item.provider?.name}</td>
                                                    <td>{
                                                        item.cptCodeList.map((cpt, index) => {
                                                            return (index === 0 ? "" : ", ") + cpt.cptCode + " " + cpt.description
                                                        })
                                                    }</td>
                                                    <td>{item.noOfSessions}</td>
                                                    <td>{item.remarks}</td>
                                                </tr>);
                                        }
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
                {
                    this.props.referral != null && this.props.referral.interventions.length > 0 &&
                    <div>
                        <div>
                            <div style={{marginTop: 5}}></div>
                            <b>Interventions</b>
                            <br/>
                            The Following Interventions Have Been Ordered
                            <div style={{marginTop: 5}}></div>

                            <table className={"visit-history-table"}>
                                <tbody>
                                <tr style={{backgroundColor: "rgba(197, 224, 181, 0.4)"}}>
                                    <th>Type</th>
                                    <th>Details</th>
                                    <th>Recommendations</th>
                                    <th>Remarks</th>
                                </tr>
                                {
                                    this.props.referral.interventions.map((item, index) => {
                                            return (
                                                <tr key={index} style={{backgroundColor: "white"}}>
                                                    <td>{InterventionTypeEnum[item.type]?.name}</td>
                                                    <td>{item.details}</td>
                                                    <td>{item.recommendations}</td>
                                                    <td>{item.remarks}</td>
                                                </tr>);
                                        }
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
            </>
        )
    }



}
